import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { generateEnhancedShareUrl } from '../../masonry-utils';
import ShareBtn from './ShareBtn';

class TwitterShareBtn extends ShareBtn {
  static get properties() {
    return {
      ...super.properties,
      post: { type: Object },
    };
  }

  constructor() {
    super();
    this.icon = faXTwitter;
    this.color = '#000000';
  }

  /**
   * Gets the Twitter share URL with enhanced URL tracking
   * @returns {string} Twitter share URL
   */
  get shareURL() {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    return `https://twitter.com/share?url=${encodeURIComponent(url)}`;
  }
}

export default TwitterShareBtn;
